import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";

// InfoTrust Brand Colors
const brandColors = {
	primary: {
		50: "#f0f8ff",
		100: "#e0f2fe",
		200: "#bae6fd",
		300: "#7dd3fc",
		400: "#79AAEB", // Primary Blue Light
		500: "#0C6DC7", // Primary Blue
		600: "#0369a1",
		700: "#084A87", // Primary Blue Dark
		800: "#075985",
		900: "#0c4a6e",
		950: "#082f49",
	},
	secondary: {
		50: "#fff7ed",
		100: "#ffedd5",
		200: "#fed7aa",
		300: "#fdba74",
		400: "#FCC358", // Secondary Orange Light
		500: "#F69F27", // Secondary Orange
		600: "#ea580c",
		700: "#FA5E28", // Secondary Orange Dark
		800: "#9a3412",
		900: "#7c2d12",
		950: "#431407",
	},
};

// Create custom InfoTrust preset
export const ThemePreset = definePreset(Aura, {
	semantic: {
		primary: brandColors.primary,
		colorScheme: {
			light: {
				primary: {
					color: brandColors.primary[500],
					contrastColor: "#ffffff",
					hoverColor: brandColors.primary[700],
					activeColor: brandColors.primary[800],
				},
				highlight: {
					background: brandColors.primary[500],
					focusBackground: brandColors.primary[700],
					color: "#ffffff",
					focusColor: "#ffffff",
				},
				formField: {
					focusBorderColor: brandColors.primary[500],
					hoverBorderColor: brandColors.primary[400],
				},
			},
			dark: {
				primary: {
					color: brandColors.primary[400],
					contrastColor: brandColors.primary[950],
					hoverColor: brandColors.primary[300],
					activeColor: brandColors.primary[200],
				},
				highlight: {
					background: "rgba(121, 170, 235, 0.16)",
					focusBackground: "rgba(121, 170, 235, 0.24)",
					color: "rgba(255,255,255,.87)",
					focusColor: "rgba(255,255,255,.87)",
				},
				formField: {
					focusBorderColor: brandColors.primary[400],
					hoverBorderColor: brandColors.primary[300],
				},
			},
		},
		focusRing: {
			width: "2px",
			style: "solid",
			color: brandColors.primary[500],
			offset: "2px",
		},
	},
	components: {
		button: {
			colorScheme: {
				light: {
					root: {
						primaryBackground: brandColors.primary[500],
						primaryHoverBackground: brandColors.primary[700],
						primaryActiveBackground: brandColors.primary[800],
						primaryColor: "#ffffff",
						secondaryBackground: brandColors.secondary[500],
						secondaryHoverBackground: brandColors.secondary[700],
						secondaryActiveBackground: brandColors.secondary[800],
						secondaryColor: "#ffffff",
					},
				},
				dark: {
					root: {
						primaryBackground: brandColors.primary[400],
						primaryHoverBackground: brandColors.primary[300],
						primaryActiveBackground: brandColors.primary[200],
						primaryColor: brandColors.primary[950],
						secondaryBackground: brandColors.secondary[400],
						secondaryHoverBackground: brandColors.secondary[300],
						secondaryActiveBackground: brandColors.secondary[200],
						secondaryColor: brandColors.secondary[950],
					},
				},
			},
		},
		inputtext: {
			colorScheme: {
				light: {
					root: {
						focusBorderColor: brandColors.primary[500],
						hoverBorderColor: brandColors.primary[400],
					},
				},
				dark: {
					root: {
						focusBorderColor: brandColors.primary[400],
						hoverBorderColor: brandColors.primary[300],
					},
				},
			},
		},
		checkbox: {
			colorScheme: {
				light: {
					root: {
						checkedBackground: brandColors.primary[500],
						checkedHoverBackground: brandColors.primary[700],
						checkedBorderColor: brandColors.primary[500],
						checkedHoverBorderColor: brandColors.primary[700],
					},
				},
				dark: {
					root: {
						checkedBackground: brandColors.primary[400],
						checkedHoverBackground: brandColors.primary[300],
						checkedBorderColor: brandColors.primary[400],
						checkedHoverBorderColor: brandColors.primary[300],
					},
				},
			},
		},
		radiobutton: {
			colorScheme: {
				light: {
					root: {
						checkedBackground: brandColors.primary[500],
						checkedHoverBackground: brandColors.primary[700],
						checkedBorderColor: brandColors.primary[500],
						checkedHoverBorderColor: brandColors.primary[700],
					},
				},
				dark: {
					root: {
						checkedBackground: brandColors.primary[400],
						checkedHoverBackground: brandColors.primary[300],
						checkedBorderColor: brandColors.primary[400],
						checkedHoverBorderColor: brandColors.primary[300],
					},
				},
			},
		},
		dropdown: {
			colorScheme: {
				light: {
					root: {
						focusBorderColor: brandColors.primary[500],
						hoverBorderColor: brandColors.primary[400],
					},
				},
				dark: {
					root: {
						focusBorderColor: brandColors.primary[400],
						hoverBorderColor: brandColors.primary[300],
					},
				},
			},
		},
		progressbar: {
			colorScheme: {
				light: {
					root: {
						background: brandColors.primary[500],
					},
				},
				dark: {
					root: {
						background: brandColors.primary[400],
					},
				},
			},
		},
	},
});
